import React, { createContext, useContext, useMemo } from 'react';
import { useHttpClientCore } from '@/shared';
import { ApiVisaMatrixAdminRepository } from '../repositories/ApiVisaMatrixAdminRepository';

export const VisaMatrixAdminDIContext = createContext<ApiVisaMatrixAdminRepository | undefined>(undefined);

export const VisaMatrixAdminDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const repository = useMemo(() => new ApiVisaMatrixAdminRepository(httpClient), [httpClient]);
  return <VisaMatrixAdminDIContext.Provider value={repository}>{children}</VisaMatrixAdminDIContext.Provider>;
};

export const useVisaMatrixAdmin = (): ApiVisaMatrixAdminRepository => {
  const repository = useContext(VisaMatrixAdminDIContext);
  if (!repository) throw new Error('useVisaMatrixAdmin must be used inside VisaMatrixAdminDIProvider');
  return repository;
};
